import { render, staticRenderFns } from "./AddPoiModalContent.vue?vue&type=template&id=04d2ff20&scoped=true&"
import script from "./AddPoiModalContent.vue?vue&type=script&lang=js&"
export * from "./AddPoiModalContent.vue?vue&type=script&lang=js&"
import style0 from "./AddPoiModalContent.vue?vue&type=style&index=0&id=04d2ff20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d2ff20",
  null
  
)

export default component.exports